<script>
import fcheader from '@/components/headerYear'
import MainLayout from '../layouts/mainLayout'
import {DateUtil} from '@/utils/date.js'
import dialog from '@/components/Dialog'
let date = new Date()
var year = date.getFullYear()
var month = date.getMonth() + 1
var initmonth = year + '年' + month + '月'
export default {
  components: {
    'fc-header': fcheader,
    MainLayout,
    'v-dialog': dialog
  },
  data () {
    return {
      nowmonth: initmonth,
      year: year,
      month: month,
      currentYear: '',
      userShiftInfos: [],
      userId: '',
      historyUserName: '',
      isPrint: false,
      allCheck: false,
      // 出力Dialog
      showPrintDialog: false,
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      }
    }
  },
  watch: {
    // 切换年份时重新加载数据
    currentYear (newvalue) {
      this.loadAllData()
    },
    allCheck () {
      if (this.allCheck) {
        for (let i = 0; i < this.checkList.length; i++) {
          this.checkList[i] = true
        }
      } else {
        for (let i = 0; i < this.checkList.length; i++) {
          this.checkList[i] = false
        }
      }
    }
  },
  computed: {
    checkList: function () {
      let checkList = []
      for (let i = 0; i < this.userShiftInfos.length; i++) {
        checkList.push(false)
      }
      return checkList
    }
  },
  created () {
    // 初始化年份和数据
    if (this.$route.params.orderDetailTime !== undefined) {
      this.year = parseInt(this.$route.params.orderDetailTime.substr(0, 4))
      this.month = this.$route.params.orderDetailTime.charAt(4) === '0' ? parseInt(this.$route.params.orderDetailTime.charAt(5)) : parseInt(this.$route.params.orderDetailTime.substr(4, 2))
      this.nowmonth = this.year + '年' + this.month + '月'
      this.currentYear = this.$route.params.orderDetailTime
    } else {
      if (this.month > 0 && this.month < 10) {
        this.currentYear = this.year + '0' + this.month
      } else {
        this.currentYear = this.year + '' + this.month
      }
    }

    this.userId = sessionStorage.getItem('userId')
    this.historyUserName = JSON.parse(sessionStorage.getItem('historyUserName'))
  },
  methods: {
    // 根据当前用户uid后台请求数据
    loadAllData () {
      this.$axios.get('user/getUsershiftByUidAndMonth', {params: {userId: this.userId, currentMonth: this.currentYear}})
        .then((response) => {
          this.userShiftInfos = response.data.userShiftInfos
          console.log(this.userShiftInfos)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 返回アカウント主页面
    goback () {
      this.$router.push({ name: 'MemberList' })
    },
    // 显示便详细
    shiftDetail (userShiftInfo) {
      sessionStorage.setItem('userShiftInfo', JSON.stringify(userShiftInfo))

      this.$router.push({name: 'MemberRecOrdOrOrderDetail', query: {name: this.historyUserName.name, namekana: this.historyUserName.namekana, orderDetailTime: this.currentYear}})
    },
    // 转化利用日（yyyyMMdd转化成MM月dd日（星期几））
    convertDate (date) {
      return DateUtil.monthDayWeek(date)
    },
    // 转化乘车/降车时间（yyyyMMddHHmmss转化成HH:mm）
    convertEstimateTime (date) {
      return DateUtil.hourMinute(date)
    },
    // 改变当前年份
    // emitChangeYear (newYear) {
    //   this.currentYear = newYear
    // },
    leftnowmonth () {
      if (this.month === 1) {
        this.month = 12
        this.year--
      } else { this.month-- }
      this.nowmonth = this.year + '年' + (this.month > 10 ? String(this.month) : ` ` + this.month) + '月'
      if (this.month > 0 && this.month < 10) {
        this.currentYear = this.year + '0' + this.month
      } else {
        this.currentYear = this.year + '' + this.month
      }
    },
    rightnowmonth () {
      if (this.month === 12) {
        this.month = 1
        this.year++
      } else { this.month++ }
      this.nowmonth = this.year + '年' + (this.month > 10 ? String(this.month) : ` ` + this.month) + '月'
      if (this.month > 0 && this.month < 10) {
        this.currentYear = this.year + '0' + this.month
      } else {
        this.currentYear = this.year + '' + this.month
      }
    },
    // 出力
    printMemberList () {
      this.isPrint = true
    },
    print () {
      let printList = []
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i]) {
          printList.push(this.userShiftInfos[i])
        }
      }
      console.log(printList)
      if (printList.length === 0) {
        this.dialogPrintOption.text = '乗車履歴 / 予約を選択してください。'
        this.dialogPrintOption.showNo = false
        this.dialogPrintOption.confirmButtonText = 'OK'
      } else {
        this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
        this.dialogPrintOption.showNo = true
        this.dialogPrintOption.cancelButtonText = 'キャンセル'
        this.dialogPrintOption.confirmButtonText = '実行'
      }
      // console.log(printList)
      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        if (printList.length !== 0) {
          this.$axios.post('user/exportUserRecord', printList, {responseType: 'arraybuffer'}).then((res) => {
            let fileName = '乗車履歴/予約.csv'
            let blob = new Blob([res.data], { type: 'application/x-xls' })
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName)
            } else {
              var link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = fileName
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }).catch(error => {
            console.log(error)
          })
        }
        this.showPrintDialog = false
      }).catch(() => {
        this.showPrintDialog = false
      })
    },
    cancel () {
      this.isPrint = false
    }
  }
}
</script>

<template>
  <main-layout>
    <div class="col-md-12 column" style="width:100%;display:flex;flex-direction: column;flex:1;margin-bottom: 30px;margin-top:18px">
      <div class="row clearfix" style="flex:0 0 40px;position: relative;">
        <div class="F3-M-27" style="position: absolute;width: 100%;">
          {{historyUserName.name}} (乗車履歴 / 予約)
        </div>
        <div class="col-md-2 column headerleft" style="vertical-align: bottom;margin-left:13px">
          <input type="button" value="会員リストに戻る" @click="goback" />
        </div>
        <div class="col-md-2 column print-div" style="float:right;width:200px;margin-right:20px">
          <button class="common-btn print-btn F2-M-19 detailed-button" @click="printMemberList" style="border:0px">一覧出力</button>
        </div>
      </div>
      <div class="row clearfix" style="flex:0 0 10px;position: relative;margin-top:-5px">
        <div style="position: absolute;width: 100%;">
          <hr class="hrheader">
        </div>
      </div>
      <div class="row clearfix" style="flex:0 0 10px;position: relative;margin-top:15px;margin-bottom:20px">
        <div style="position: absolute;width: 100%;">
          <div class="header-center" style="margin-top:15px">
            <div class="center-body" style="width:320px;">
              <span class="prev-month" @click="leftnowmonth"><img v-show="!isPrint" src="@/assets/button/triangle_blue_left_button.png" style="height: 20px;"></span>
              <span class="title nowmonth F1-R-27" >{{nowmonth}}</span>
              <span class="next-month" @click="rightnowmonth"><img v-show="!isPrint" src="@/assets/button/triangle_blue_right_button.png"  style="height: 20px;"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="table-container" style="flex: 8;margin-top:40px">
        <div class=" table-header tb-header" style="padding-right:10px; flex:0 0 30px">
          <table>
            <thead>
              <tr class="theader bgc9 F2-R-15">
                <td v-show="isPrint" class="trborder" style="width:5%">
                  <div >
                      <input type="checkbox" v-model="allCheck" class="checkbox-style">
                  </div>
                </td>
                <td class="trborder" :style="isPrint?'width:13%':'width:18%'">利用日</td>
                <td class="trborder" style="width:46%">乗車便名</td>
                <td class="trborder">乗車時間</td>
                <td class="trborder">降車時間</td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-body scrollbar">
          <table class="table" style="margin-bottom:0px;">
            <tbody>
              <tr class="contenttr bgc5h F3-R-18" v-for='(item,index) in userShiftInfos' :key="item.uid">
                <td v-show="isPrint" class="trborder" style="width:5%">
                  <div >
                      <input type="checkbox" v-model="checkList[index]" class="checkbox-style">
                  </div>
                </td>
                <td class="trborder bodytext" :style="isPrint?'width:13%':'width:18%'" @click="shiftDetail(item)">{{convertDate(item.useTime)}}</td>
                <td class="trborder bodytext" style="width:46%" @click="shiftDetail(item)">{{item.shiftTitle}}</td>
                <td class="trborder" @click="shiftDetail(item)">{{convertEstimateTime(item.startEstimateTime)}}</td>
                <td class="trborder" @click="shiftDetail(item)">{{convertEstimateTime(item.arriveEstimateTime)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- footer -->
      <div v-show="isPrint" class="row clearfix footer">
        <div class="col-md-6 column">
          <button class="print-button" style="float:right" @click="print">出力</button>
        </div>
        <div class="col-md-6 column">
          <button class="print-button" style="float:left" @click="cancel">キャンセル</button>
        </div>
      </div>
      <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
    </div>
  </main-layout>
</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
.name-strong{
  font-size: 30px;
}

.user-btn{
   width: 200px
}
.headerleft{
  width: 210px;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  line-height: 40px;
  width: 100%;
  text-indent: 30px;
  font-size: 18px;
}

.hrheader{
  background-color: rgb(128, 128, 128);
  height: 1px;
  width: 600px;
}

td{
  width:18%;
  }
.print-div{
   display :flex;
   flex-direction:  row-reverse
}
.print-btn{
    flex: 1
}
tr:hover {
   background-color: rgb(110, 110, 110);
}
.tb-header{
  padding-right:10px;
}

.nowmonth{
  height: 45px;
  line-height: 45px;
  color: black;
  // min-width: 160px;
}
.img-style{
  width: 20px;
  padding-top: 10px;
}
.header-center {
    flex:2;
    text-align:center;
    font-size: 28px;
    display: flex;
    justify-content: center;
    & > .center-body {
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
    }
    .title{
      margin: 0 20px;
      // min-width: 160px;
    }
    .prev-month,.next-month{
      cursor: pointer;
    }
}
 .checkbox-style{
    width:20px;
    height:20px;
  }
.footer{
    flex:1;
    width: 100%;
    margin: 0px;
    margin-bottom: 0px;
    margin-top:30px;
    display: flex;
    align-items: flex-end;
  }
  .print-button{
    width: 60%;
    height: 50px;
    border-radius: 10px;
    background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
    border: 0px;
    /* margin: 30px; */
    font-size: 22px;
    color: #fff;
    background-color: #717171;
  }
</style>



// WEBPACK FOOTER //
// src/router/views/MemberList_OrderAndDetail.vue